/**
 * The keys of the FCMenu token for various fields.
 * Example decoded token:
 * {
 *   1: "101575923",
 *   2: "pautyler",
 *   3: "secure",
 *   4: "BFI1",
 *   5: "2005",
 *   6: null,
 *   7: "en_US",
 *   iss: "fcmenu.integ.amazon.com",
 *   exp: 1654058315
 * }
 */
export const FCMENU_EMPLOYEE_ID_TOKEN_KEY = 1;
export const FCMENU_LOGIN_TOKEN_KEY = 2;
export const FCMENU_WAREHOUSE_ID_TOKEN_KEY = 4;
export const FCMENU_LOCALE_TOKEN_KEY = 7;

/**
 * Example FCMenu for CORP aka Internal
 */
export const FCMENU_DEV_TOKEN_INTERNAL = 'REPLACE_WHEN_RUNNING_LOCALLY'; // This is only for testing Corp
export const FCMENU_BETA_URL_INTERNAL = 'https://fcmenu.integ.amazon.com/secure/login';
export const FCMENU_PROD_URL_INTERNAL = 'https://fcmenu.amazon.com/secure/login';

/**
 * Example FCMenu for MOC aka External
 */
export const FCMENU_BETA_URL_EXTERNAL = 'https://menu.beta.aft.amazonoperations.app';
export const FCMENU_PROD_URL_EXTERNAL = 'https://menu.na.aft.amazonoperations.app';

/**
 * FCMenu cookie values
 */
export const FCMENU_SENSITIVE_COOKIE = 'fcmenu-sensitive';
export const FCMENU_LOCALE_COOKIE = 'fcmenu-locale';
export const FCMENU_EMPLOYEE_LOGIN_COOKIE = 'fcmenu-employeeLogin';
export const FCMENU_EMPLOYEE_ID_COOKIE = 'fcmenu-employeeId';
export const FCMENU_WAREHOUSE_ID_COOKIE = 'fcmenu-warehouseId';
/**
 * This token is a dummy token for MOC endpoints.
 */
export const FCMENU_MOC_DUMMY_USER_TOKEN = 'MOC_USER_TOKEN';
